import React, { useEffect, useState, useMemo } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
import { FaSort } from "react-icons/fa";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;



const StudentData = () => {
  const [studentsData, setStudentsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [studentStats, setStudentStats] = useState();
  console.log("studentStats", studentStats);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Sorting state
  useEffect(() => {
    const fetchStudentStats = async () => {
      try {
        const res = await axiosInstance.get("admin/student-statistics");
        console.log("res?.data?.data",res?.data?.data);
        setStudentStats(res?.data?.data);
      } catch (error) {
        console.error("Error fetching instructor statistics:", error.message);
      }
    };

    fetchStudentStats();
  }, []);
  const staticData = [
    {
      name: "Total Student",
      total: studentStats?.totalStudents,
      boxShadow: "Dashboard-color-one",
      color: "color-one",
    },
    {
      name: "Paid Student",
      total: studentStats?.paidStudents,
      boxShadow: "Dashboard-color-two",
      color: "color-two",
    },
    {
      name: "Pending Verification",
      total: studentStats?.pendingVerification,
      boxShadow: "Dashboard-color-three",
      color: "color-three",
    },
    {
      name: "Recent Joined",
      total: studentStats?.justJoined,
      boxShadow: "Dashboard-color-four",
      color: "color-four",
    },
  ];
  const { data, startIndex, totalPageCount } = getPaginatedData(
    studentsData,
    currentPage
  );

  useEffect(() => {
    const fetchStudentReport = async () => {
      try {
        const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/student-report`);
        setStudentsData(res?.data?.data);
      } catch (error) {
        console.error("Error fetching student report:", error.message);
      }
    };

    fetchStudentReport();
  }, []);


  // Sorting handler
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Sorted data
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return studentsData;
    const sorted = [...studentsData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle numeric sorting
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "asc"
          ? aValue - bValue
          : bValue - aValue;
      }

      // Handle string sorting
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return 0;
    });
    return sorted;
  }, [studentsData, sortConfig]);

  // Helper to render sort icons
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="text-gray-400" />;
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Summary Report For Students</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="flex-dashboard-new-1">
        {staticData && staticData?.map((item, index) => (
          <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
            <p className="font-custom-p">{item.name}</p>
            <p className={`font-increase ${item.color}`}>{item.total}</p>
          </div>
        ))}
      </div>

      <div className="page-data-new">
        {data && data?.length > 0 ? (
          <p className="showing-result">
            Showing page {currentPage} of {totalPageCount} results
          </p>
        ) : (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {data && data.length === 0 ? (
          <Loading />
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                <th
                  onClick={() => handleSort("Sno")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    S.no {renderSortIcon("Sno")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("StudentId")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Student Id {renderSortIcon("StudentId")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("StudentName")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Student Name {renderSortIcon("StudentName")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Courses")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Courses {renderSortIcon("Courses")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("AmountPaid")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Amount Paid {renderSortIcon("AmountPaid")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Completed")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Total Completed {renderSortIcon("Completed")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("TotalHours")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Total Hours {renderSortIcon("TotalHours")}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedData && sortedData?.map((ele, index) => (
                <tr key={index}>
                  <td className="cell">{currentPage * 10 - 10 + index + 1}</td>
                  <td className="cell">{ele.StudentId}</td>
                  <td className="cell">{ele.StudentName}</td>
                  <td className="cell">{ele.Courses}</td>
                  <td className="cell">$ {ele.AmountPaid}</td>
                  <td className="cell">{ele.Completed}</td>
                  <td className="cell">
                    {ele.TotalHours === null ? 0 : ele.TotalHours}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="pageNumbers-sudents">
        <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </div>
  );
};

export default StudentData;
